import cx from "classnames";
import { forwardRef } from "react";

import { useSidebar } from "./useSidebar";

export const SidebarRail = forwardRef<
  HTMLButtonElement,
  React.ComponentProps<"button">
>(({ className, ...props }, ref) => {
  const { toggleSidebar } = useSidebar();

  return (
    <button
      ref={ref}
      data-sidebar="rail"
      aria-label="Toggle Sidebar"
      tabIndex={-1}
      onClick={toggleSidebar}
      title="Toggle Sidebar"
      className={cx(
        "absolute inset-y-0 z-[2] hidden w-4 -translate-x-1/2 bg-transparent transition-all ease-out group-data-[side=left]:-right-4 group-data-[side=right]:-left-0.5 sm:flex",
        "after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] hover:after:bg-puntt-neutral-gray-5",
        // Hovering the header collapse toggle (open OR collapsed) lights up the
        // SAME rail line, so users associate that button with this divider. The
        // toggle and this rail share the `group`/`peer` sidebar root, so a
        // `group-has-[…:hover]` match drives the identical `::after` highlight.
        "group-has-[[data-testid=sidebar-collapse-trigger]:hover]:after:bg-puntt-neutral-gray-5",
        "[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full group-data-[collapsible=offcanvas]:hover:bg-puntt-neutral-gray-3",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        className,
      )}
      {...props}
    />
  );
});

SidebarRail.displayName = "SidebarRail";
